import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import KpiCard from "../common/KpiCard";
import { fmtINR, fmtNum } from "../../utils/formatters";
import { T } from "../../constants/theme";
import {
  kpiTotals,
  posData,
  purchaseData,
  userPartyData,
} from "../../data/dashboardMockData";
import * as url from "../../../../../routes/route_url";

const KPISection = ({ data, loading, onNavigate }) => {
  const topKPIs = useMemo(
    () => [
      {
        title: "Total Companies",
        value: data.companies.length || kpiTotals.totalCompanies,
        color: T.blue,
        icon: "bx bx-buildings",
        path: url.COMPANY_lIST,
        sub: "Active business entities",
      },
      {
        title: "Company Groups",
        value: data.companyGroups.length || kpiTotals.totalCompanyGroups,
        color: T.green,
        icon: "bx bx-grid-alt",
        path: url.COMPANYGROUP_lIST,
        sub: "Consolidated group view",
      },
      {
        title: "Total Users",
        value: data.users.length || kpiTotals.totalUsers,
        color: T.teal,
        icon: "bx bx-user",
        path: url.USER_lIST,
        sub: `${userPartyData.users.active} active today`,
      },
      {
        title: "Total Parties",
        value: data.parties.length || kpiTotals.totalParties,
        color: T.yellow,
        icon: "bx bx-store",
        path: url.PARTY_lIST,
        sub: "Distributors & retailers",
      },
      {
        title: "Total Pages",
        value: data.pages.length || kpiTotals.totalPages,
        color: "#02a499",
        icon: "bx bx-file",
        path: url.PAGE_lIST,
        sub: "Across all modules",
      },
      {
        title: "Total Employees",
        value: data.employees.length || kpiTotals.totalEmployees,
        color: T.teal,
        icon: "bx bx-id-card",
        path: url.EMPLOYEE_lIST,
        sub: "All companies",
      },
      {
        title: "POS Sales Today",
        value: fmtINR(posData.totalPosSale),
        color: T.green,
        icon: "bx bx-rupee",
        path: null,
        sub: `${fmtNum(posData.totalSaleTransactions)} transactions`,
      },
      {
        title: "Total Purchase",
        value: fmtINR(purchaseData.totalAmount),
        color: T.orange,
        icon: "bx bx-cart",
        path: null,
        sub: `${purchaseData.pendingOrders} pending approval`,
      },
    ],
    [data]
  );

  return (
    <Row style={{ marginBottom: "4px" }}>
      {topKPIs.map((item, idx) => (
        <Col xl={3} md={4} sm={6} key={idx}>
          <KpiCard
            item={item}
            loading={loading}
            onNav={() => item.path && onNavigate(item.path)}
          />
        </Col>
      ))}
    </Row>
  );
};

export default KPISection;
